// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button[data-v-d344d328]{border:0;margin:0;outline:none;padding:0}", ""]);
// Exports
module.exports = exports;
